document.addEventListener('click', function (e) {
  const link = e.target.closest('a[data-switch-to]');
  if (!link) return;

  const popup = document.getElementById('login-popup');

  // PAGE MODE → let browser navigate normally
  if (!popup || !popup.open) return;

  // POPUP MODE → prevent navigation
  e.preventDefault();

  const target = link.dataset.switchTo;

  document.querySelectorAll('[data-auth-view]').forEach(view => {
    view.hidden = view.dataset.authView !== target;
  });
});

document.addEventListener('click', function (e) {
  const logo = e.target.closest('.login-page__wrapper .login-popup__logo');
  if (!logo) return;

  window.location.href = '/';
});
